
import { defineComponent } from 'vue'
import CattleImport from '@/components/CattleImport.vue'
import UserImpersonation from '@/components/UserImpersonation.vue'

export default defineComponent({
  name: 'Setting',
  components: {
    CattleImport,
    UserImpersonation,
  },
})
